import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const fastShippingCopySignedOutSelector = createSelector(testTargetOffersSelector, offers => offers.fastShippingCopySignedOut || Empty.Object);

export { fastShippingCopySignedOutSelector };
